import React from "react";

export const AchievmentsIcon = () => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.81307 0H2.27362V0.810651L0 0.810651V4.61308C0 6.08263 1.53483 7.29193 3.04111 7.41773C3.53559 7.98385 4.40536 8.39507 5.17947 8.57041V9.56427C4.43921 9.80723 3.1169 10.3781 3.04111 11H8.12142C8.04489 10.3781 6.58788 9.80644 5.84615 9.56427V8.57041C6.6232 8.39507 7.53197 7.98385 8.02719 7.41773C9.53273 7.29193 11 6.08263 11 4.61308V0.810651H8.81307V0ZM0.698178 1.53119H2.22064V4.80651C2.22064 5.45283 2.37664 6.0677 2.65111 6.62123C1.51202 6.2336 0.698178 5.23503 0.698178 4.06662V1.53119ZM6.66161 5.52595L5.5252 4.85683L4.38756 5.52595L4.60478 4.11065L3.68497 3.10894L4.95576 2.90215L5.5252 1.6158L6.0934 2.90215L7.36419 3.10894L6.445 4.11065L6.66161 5.52595ZM8.35022 6.72581C8.62617 6.14711 8.78437 5.50708 8.78437 4.8301V1.5523H10.3105V4.05719C10.3105 5.27827 9.49299 6.32088 8.35022 6.72581Z"
      />
    </svg>
  );
};
